module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagMovingAverageDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "large"
    }
  }) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Automatic"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Automatic")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Automatic"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Hour"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Hour")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Hour"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Day"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Day")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Day"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]) + "\n                              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])]), _vm._v(" "), (_vm.flagMovingAverageDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 align-center"
  }, [(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display001H),
      expression: "display001H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display001H) ? _vm._i(_vm.display001H, null) > -1 : (_vm.display001H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display001H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display001H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display001H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display001H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 1 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display004H),
      expression: "display004H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display004H) ? _vm._i(_vm.display004H, null) > -1 : (_vm.display004H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display004H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display004H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display004H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display004H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 4 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display006H),
      expression: "display006H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display006H) ? _vm._i(_vm.display006H, null) > -1 : (_vm.display006H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display006H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display006H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display006H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display006H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 6 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display012H),
      expression: "display012H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display012H) ? _vm._i(_vm.display012H, null) > -1 : (_vm.display012H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display012H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display012H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display012H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display012H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 12 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display024H),
      expression: "display024H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display024H) ? _vm._i(_vm.display024H, null) > -1 : (_vm.display024H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display024H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display024H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display024H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display024H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 1 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display072H),
      expression: "display072H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display072H) ? _vm._i(_vm.display072H, null) > -1 : (_vm.display072H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display072H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display072H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display072H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display072H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 3 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display168H),
      expression: "display168H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display168H) ? _vm._i(_vm.display168H, null) > -1 : (_vm.display168H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display168H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display168H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display168H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display168H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 7 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display336H),
      expression: "display336H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display336H) ? _vm._i(_vm.display336H, null) > -1 : (_vm.display336H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display336H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display336H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display336H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display336H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 14 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display720H),
      expression: "display720H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display720H) ? _vm._i(_vm.display720H, null) > -1 : (_vm.display720H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display720H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display720H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display720H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display720H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 30 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e()])]), _vm._v(" "), (_vm.flagMovingAverageDataAvailable) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.histogramDataDownloadDay,
      "name": "ChannelHistogramDayData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eae2f484","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/MovingAverageGraph.vue
// module id = 1587
// module chunks = 4